import { BaseButton, BaseNavLink } from '@enter/core';
import { mdiEmailOutline, mdiEmailArrowRight } from '@mdi/js';
import Icon from '@mdi/react';
import { DataTableCard, PageLayout, PageLayoutHeader, PageLayoutRow, PageLayoutTitle } from 'components';
import React from 'react';
import { useParams } from 'react-router-dom';
import * as S from './fax.styles';
import { InboxFax } from './inbox/inbox';
import { OutboxFax } from './outbox/outbox';

export const Fax = () => {
    const { tab, accountId } = useParams<{ tab: 'inbox' | 'outbox'; accountId?: string }>();

    return (
        <PageLayout>
            <PageLayoutRow>
                <PageLayoutHeader>
                    <PageLayoutTitle>Faxes</PageLayoutTitle>
                </PageLayoutHeader>
            </PageLayoutRow>
            <PageLayoutRow>
                <DataTableCard size="large">
                    <S.TabsContainer>
                        <BaseNavLink to={accountId ? `/${accountId}/fax/inbox` : 'fax/inbox'} disabled={tab === 'inbox'}>
                            {(linkProps): React.ReactElement => (
                                <BaseButton variant="outlined" disabled={linkProps.active}>
                                    <Icon path={mdiEmailOutline} size={0.75} />
                                    <span>Inbox</span>
                                </BaseButton>
                            )}
                        </BaseNavLink>
                        <BaseNavLink to={accountId ? `/${accountId}/fax/outbox` : 'fax/outbox'} disabled={tab === 'outbox'}>
                            {(linkProps): React.ReactElement => (
                                <BaseButton variant="outlined" disabled={linkProps.active}>
                                    <Icon path={mdiEmailArrowRight} size={0.75} />
                                    <span>Outbox</span>
                                </BaseButton>
                            )}
                        </BaseNavLink>
                    </S.TabsContainer>

                    {tab === 'inbox' && <InboxFax />}
                    {tab === 'outbox' && <OutboxFax />}
                </DataTableCard>
            </PageLayoutRow>
        </PageLayout>
    );
};
